// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-A1":"A1_vanlife-roadtrips-A1__SbpTP"};